import { useFonts } from 'expo-font';

/**
 * Loads MarketPryce brand fonts. Call once at the root and gate render until
 * `loaded` is true so no `<Text>` ever flashes the system fallback.
 *
 * Three families: FKScreamer (display), Druk Wide (numbers + sub-heads),
 * Inter (body).
 */
export function useAppFonts(): { loaded: boolean; error: Error | null } {
  const [loaded, error] = useFonts({
    'FKScreamer-Regular': require('@/assets/fonts/fk-screamer/FKScreamer-Regular.otf'),
    'FKScreamer-Medium': require('@/assets/fonts/fk-screamer/FKScreamer-Medium.otf'),
    'FKScreamer-Bold': require('@/assets/fonts/fk-screamer/FKScreamer-Bold.otf'),
    'FKScreamer-Black': require('@/assets/fonts/fk-screamer/FKScreamer-Black.otf'),
    'DrukWide-Bold': require('@/assets/fonts/druk-wide/Druk-Wide-Bold.otf'),
    'DrukWide-Medium': require('@/assets/fonts/druk-wide/Druk Wide Medium.otf'),
    'DrukWide-Heavy': require('@/assets/fonts/druk-wide/Druk Wide Heavy.otf'),
    'DrukWide-Super': require('@/assets/fonts/druk-wide/Druk Wide Super.otf'),
    'Inter-Regular': require('@/assets/fonts/inter/Inter-Regular.ttf'),
    'Inter-Medium': require('@/assets/fonts/inter/Inter-Medium.ttf'),
    'Inter-SemiBold': require('@/assets/fonts/inter/Inter-SemiBold.ttf'),
    'Inter-Bold': require('@/assets/fonts/inter/Inter-Bold.ttf'),
  });

  return { loaded: loaded || !!error, error };
}
